module.exports = __webpack_public_path__ + "img/financial-income.3c6dedfd.png";